import { combineReducers } from "redux";
import { apiReducer } from '../../utils/api/reducer';
import { Constants } from './constants';

export const trendingReducer = combineReducers({
  trends: apiReducer(Constants.SET_TRENDS),
});